module.exports = __webpack_public_path__ + "static/media/code-1.0afa105b.jpg";